/* Furrmacy · Our Story chapters: reveals and scroll-linked effects (sections/fm-story.liquid) */
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-st-ready')) return;
    root.setAttribute('data-st-ready', '1');
    var still = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || root.classList.contains('fm-st-still');
    root.classList.remove('fm-st-on', 'fm-st-still');
    root.classList.add(still ? 'fm-st-still' : 'fm-st-on');
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var clamp = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };

    /* numbers count up once their badge is on screen */
    function countUp(el) {
      var to = parseFloat(el.getAttribute('data-st-count')) || 0, t0 = Date.now(), dur = 1400;
      if (still || !to) { el.textContent = to; return; }
      (function step() {
        var p = clamp((Date.now() - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * e);
        if (p < 1) setTimeout(step, 32);
      })();
    }

    /* one-shot reveals */
    var ins = $$('[data-st-in], [data-st-lines], [data-st-wipe]');
    var show = function (el) {
      el.classList.add('is-in');
      Array.prototype.forEach.call(el.querySelectorAll('[data-st-count]'), countUp);
    };
    if (still || !('IntersectionObserver' in window)) { ins.forEach(show); }
    else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
      ins.forEach(function (el) { io.observe(el); });
    }

    /* scroll-linked effects */
    var scrubs = $$('[data-st-scrub]'), wordSets = $$('[data-st-words]'), frames = $$('[data-st-parallax]'),
        grows = $$('[data-st-grow]'), progs = $$('[data-st-prog]'),
        chapters = $$('[data-st-chapter]'), links = $$('[data-st-navlink]'), bar = root.querySelector('[data-st-progress]');

    function headerOffset() {
      var h = document.querySelector('.fm-header-section'), off = 0;
      if (h) { var pos = getComputedStyle(h).position; if (pos === 'sticky' || pos === 'fixed') off = Math.max(0, h.getBoundingClientRect().bottom); }
      root.style.setProperty('--st-top', Math.round(off) + 'px');
      /* chapter links land below the header and the chapter bar */
      var navH = root.querySelector('.fm-story__nav') ? root.querySelector('.fm-story__nav').offsetHeight : 0;
      chapters.forEach(function (ch) { ch.style.scrollMarginTop = Math.round(off + navH) + 'px'; });
      return off;
    }

    function update() {
      var vh = window.innerHeight || document.documentElement.clientHeight, off = headerOffset();
      if (!still) {
        scrubs.forEach(function (el) {
          var r = el.getBoundingClientRect();
          el.style.setProperty('--st-s', clamp((vh * 0.86 - r.top) / (vh * 0.3)).toFixed(3));
        });
        wordSets.forEach(function (el) {
          var r = el.getBoundingClientRect(), w = el.querySelectorAll('.fm-st-word'), n = w.length;
          var p = clamp((vh * 0.88 - r.top) / (r.height + vh * 0.32));
          for (var i = 0; i < n; i++) w[i].style.setProperty('--st-o', (0.14 + 0.86 * clamp(p * n * 1.15 - i)).toFixed(3));
        });
        frames.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          var p = clamp((vh - r.top) / (vh + r.height)), range = (parseFloat(el.getAttribute('data-st-parallax')) || 0.1) * r.height;
          el.style.setProperty('--st-py', ((0.5 - p) * range).toFixed(1) + 'px');
        });
        grows.forEach(function (el) {
          var r = el.getBoundingClientRect();
          el.style.setProperty('--st-g', (clamp((vh * 0.98 - r.top) / (r.height * 0.95)) * 1.2).toFixed(3));
        });
        /* 0 → 1 while the element travels through the screen (line circles, round image, banner photo) */
        progs.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -100 || r.top > vh + 100) return;
          el.style.setProperty('--p', clamp((vh - r.top) / (vh + r.height)).toFixed(3));
        });
      }
      /* chapter bar */
      if (links.length) {
        var cur = 0;
        for (var c = 0; c < chapters.length; c++) if (chapters[c].getBoundingClientRect().top < off + vh * 0.4) cur = c;
        links.forEach(function (a, i) { a.classList.toggle('is-active', i === cur); if (i === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
        if (bar) {
          var rr = root.getBoundingClientRect();
          bar.parentNode.parentNode.style.setProperty('--st-p', clamp((off - rr.top) / Math.max(1, rr.height - vh)).toFixed(4));
        }
      }
    }

    var queued = false, settle = null;
    function request() {
      /* one more pass once scrolling stops: the site header can still be sliding in or out */
      clearTimeout(settle);
      settle = setTimeout(update, 360);
      if (queued) return;
      queued = true;
      var done = false, run = function () { if (done) return; done = true; queued = false; update(); };
      if (window.requestAnimationFrame) window.requestAnimationFrame(run);
      setTimeout(run, 80);
    }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    update();
    setTimeout(update, 400);
    setTimeout(update, 1500);
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-fm-story]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
